/* tslint:disable */
/* eslint-disable */
/**
 * Ad Asset Generation Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { AssetGenerationProgressFromJSON, AssetGenerationProgressToJSON, ImgPromptRequestFromJSON, ImgPromptRequestToJSON, UploadAssetPost200ResponseFromJSON, UploadAssetPost200ResponseToJSON, } from '../models/index';
/**
 *
 */
export class DefaultApi extends runtime.BaseAPI {
    /**
     */
    async assetAssetIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters['assetId'] == null) {
            throw new runtime.RequiredError('assetId', 'Required parameter "assetId" was null or undefined when calling assetAssetIdGet().');
        }
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/asset/{assetId}`.replace(`{${"assetId"}}`, encodeURIComponent(String(requestParameters['assetId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     */
    async assetAssetIdGet(requestParameters, initOverrides) {
        const response = await this.assetAssetIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async generateImgPostRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/generate/img`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ImgPromptRequestToJSON(requestParameters['imgPromptRequest']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => AssetGenerationProgressFromJSON(jsonValue));
    }
    /**
     */
    async generateImgPost(requestParameters = {}, initOverrides) {
        const response = await this.generateImgPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async statusAssetIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters['assetId'] == null) {
            throw new runtime.RequiredError('assetId', 'Required parameter "assetId" was null or undefined when calling statusAssetIdGet().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/status/{assetId}`.replace(`{${"assetId"}}`, encodeURIComponent(String(requestParameters['assetId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => AssetGenerationProgressFromJSON(jsonValue));
    }
    /**
     */
    async statusAssetIdGet(requestParameters, initOverrides) {
        const response = await this.statusAssetIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async uploadAssetPostRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'image/png';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/upload/asset`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'],
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => UploadAssetPost200ResponseFromJSON(jsonValue));
    }
    /**
     */
    async uploadAssetPost(requestParameters = {}, initOverrides) {
        const response = await this.uploadAssetPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
